/**
 * Single source of truth for env-var reads in the app bundle.
 *
 * Vite injects `import.meta.env.*` at build time (computed values via `define`
 * in vite.config.ts, plain `.env` passthroughs via `envPrefix`). See
 * `vite-env.d.ts` for the typed shape.
 */

export const PUBLIC_PTC_SERVER_URL = import.meta.env.PUBLIC_PTC_SERVER_URL ?? "";
export const PUBLIC_PTC_JOBS_URL = import.meta.env.PUBLIC_PTC_JOBS_URL ?? "";
export const PUBLIC_PTC_STAFF_URL = import.meta.env.PUBLIC_PTC_STAFF_URL ?? "";
export const PUBLIC_PTC_MANAGE_URL = import.meta.env.PUBLIC_PTC_MANAGE_URL ?? "";
export const PUBLIC_PTC_TIME_URL = import.meta.env.PUBLIC_PTC_TIME_URL ?? "";
export const PUBLIC_PTC_HELP_SITE = import.meta.env.PUBLIC_PTC_HELP_SITE ?? "";
export const PUBLIC_PTC_BILLING_KEY = import.meta.env.PUBLIC_PTC_BILLING_KEY ?? "";
export const PUBLIC_PTC_GOOGLE_STATIC_MAPS_KEY = import.meta.env.PUBLIC_PTC_GOOGLE_STATIC_MAPS_KEY ?? "";
export const PUBLIC_PTC_ENABLED_FEATURES = import.meta.env.PUBLIC_PTC_ENABLED_FEATURES ?? "";
export const PUBLIC_PTC_BETA_FEATURES = import.meta.env.PUBLIC_PTC_BETA_FEATURES ?? "";
export const PUBLIC_PTC_LOAD_INVOICES_ADMIN = import.meta.env.PUBLIC_PTC_LOAD_INVOICES_ADMIN ?? "";
export const DEV_PTC_ENABLE_SW = import.meta.env.DEV_PTC_ENABLE_SW === "true";
export const PUBLIC_PTC_ONESIGNAL_APP_ID = import.meta.env.PUBLIC_PTC_ONESIGNAL_APP_ID ?? "";
export const PUBLIC_PTC_ONESIGNAL_LOG_LEVEL = import.meta.env.PUBLIC_PTC_ONESIGNAL_LOG_LEVEL;
export const PUBLIC_PTC_HELPSCOUT_BEACON_ID = import.meta.env.PUBLIC_PTC_HELPSCOUT_BEACON_ID ?? "";

export const BASE_URL = import.meta.env.BASE_URL;

export const IS_DEV = import.meta.env.DEV;
